<template>
  <div
    class="  px-10 mt-7">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row>
            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/balance.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">My Balance</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">$12,750</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/income.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Income</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">$5,600</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/expense.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Expense</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">$3,460</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="3">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Distributor Amanata"  
                          :src="require('@/assets/icon/totalSaving.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #4828a1;" class="fs-16 mb-1">Total Saving</v-list-item-title>

                        <v-list-item-subtitle class="fs-25 font-weight-medium color-dark-blue">$7,920</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              <div class="fs-22 mb-3 color-dark-blue font-weight-medium">
                Last Transaction
              </div>

              <v-card flat class="pa-5 py-6 border-radius-card">
                <table style="width: 100%">
                  <tr
                    v-for="(item, i) in transaction"
                    :key="i">
                    <td>
                      <div class="d-flex align-center">
                        <div class="mr-4">
                          <v-avatar class="my-1" size="55" tile>
                            <v-img
                              contain
                              alt="Distributor Amanata"  
                              :src="item.image_url"
                              class="">
                              <template v-slot:placeholder>
                                <v-row
                                  class=" "
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    size="20"
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </div>
                        <div>
                          <div>
                            <div style="color: #232323;" class="fs-16 font-weight-medium">{{ item.name }}</div>
      
                            <div class="color-light-blue fs-15">{{ item.date }}</div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="fs-16 color-light-blue">
                        {{ item.category }}
                      </div>
                    </td>

                    <td>
                      <div class="fs-16 color-light-blue">
                        {{ item.carbs }}
                      </div>
                    </td>

                    <td>
                      <div class="fs-16 color-light-blue">
                        {{ item.status }}
                      </div>
                    </td>

                    <td class="text-right">
                      <div :style="parseInt(item.amount) > 0 ? 'color: #41D4A8;' : 'color: #FF4B4A;'">
                        {{ item.amount }}
                      </div>
                    </td>

                  </tr>
                </table>
              </v-card>

            </v-col>

            <v-col cols="12" md="4">
              <div class="mb-3 d-flex align-center">
                <div class="fs-22 color-dark-blue font-weight-medium">
                  My Cards
                </div>

                <v-spacer />

                <div class="fs-17 color-dark-blue">
                  see all
                </div>
              </div>

              <v-card flat color="#4C49ED" class="border-radius-card white--text">
                <div class="pa-7 pb-5">

                  <div class="d-flex mb-3">
                    <div>
                      <div class="fs-12">
                        Balance
                      </div>
                      <div class="fs-20">
                        $5,756
                      </div>
                    </div>
                    <v-spacer />
                    <div>
                      <v-img
                        contain
                        alt="Distributor Amanata"  
                        width="35"
                        src="@/assets/icon/chipCard.png"
                        class="mx-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                  </div>


                  <v-row>
                    <v-col cols="6">
                      <div class="fs-12">
                        CARD HOLDER
                      </div>
                      <div class="fs-15">
                        Eddy Cusuma
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="fs-12">
                        VALID THRU
                      </div>
                      <div class="fs-15">
                        12/22
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <v-img
                  alt="Distributor Amanata"
                  height="70"
                  class="align-center justify-center white--text px-7"
                  src="@/assets/background/dashboardWhite.png"
                  >
                  
                  <div class="d-flex">
                    <div class="fs-22">
                      3778 **** **** 1234
                    </div>

                    <v-spacer />

                    <div>
                      <v-img
                        contain
                        alt="Distributor Amanata"  
                        width="44"
                        src="@/assets/icon/masterCardWhite.png"
                        class="mx-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>
                  </div>
                </v-img>
                
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="8">
              <div class="fs-22 mb-3 color-dark-blue font-weight-medium">
                Debit & Credit Overview              
              </div>

              <v-card flat class="pa-5 border-radius-card">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 213px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 fs-17 color-light-blue">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-card-text>
                <div v-if="!process.load && weekly">
                  <div style="color: #4828a1; position: absolute;" class="fs-15">
                    <b style="color: #333B69;">$7,560</b> Debited & <b style="color: #333B69;">$5,420</b> Credited in this Week
                  </div>
                  <div id="chart" v-if="!process.load && weekly">
                    <apexchart type="bar" height="278" :options="weekly.chartOptions" :series="weekly.series"></apexchart>
                  </div>
                </div>
              </v-card>

            </v-col>

            <v-col cols="12" md="4">
              <div class="mb-3 d-flex align-center">
                <div class="fs-22 color-dark-blue font-weight-medium">
                  Invoices Sent
                </div>
              </div>

              <v-card flat class="pa-3 border-radius-card">
                <v-list
                  subheader
                  two-line
                  dense
                >
                  <v-list-item
                    v-for="(item, i) in invoice"
                    :key="i"
                    class="my-4"
                    style="min-height: 55px; height: 55px;"
                  >
                    <v-list-item-avatar class="my-1" size="55" tile>
                      <v-img
                        contain
                        alt="Distributor Amanata"  
                        :src="item.img"
                        class="">
                        <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title style="color: #B1B1B1;" class="fs-16 mb-1">{{ item.title }}</v-list-item-title>

                      <v-list-item-subtitle class="color-light-blue">{{ item.date }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action class="fs-16 color-light-blue">
                      {{ item.amount }}
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        invoice: [
          {
            title: 'Apple Store',
            date: '5h ago',
            img: require('@/assets/icon/apple.png'),
            amount: '$450'
          },
          {
            title: 'Michael',
            date: '2 days ago',
            img: require('@/assets/icon/personYellow.png'),
            amount: '$160'
          },
          {
            title: 'Playstation',
            date: '5 days ago',
            img: require('@/assets/icon/ps.png'),
            amount: '$5,400'
          },
          {
            title: 'William',
            date: '10 days ago',
            img: require('@/assets/icon/person.png'),
            amount: '$400'
          }
        ],

        transaction: [
          {
            name: 'Spotify Subscription',
            category: 'Shopping',
            status: 'Pending',
            carbs: '1234 ****',
            date: '28 Jan, 12.30 AM',
            amount: '-2,500',
            image_url: require('@/assets/icon/spotify.png')
          },
          {
            name: 'Mobile Service',
            category: 'Transfer',
            status: 'Completed',
            carbs: '1234 ****',
            date: '24 Jan, 10.30 AM',
            amount: '+750',
            image_url: require('@/assets/icon/mobile.png')
          },
          {
            name: 'Emilly Wilson',
            category: 'Transfer',
            status: 'Completed',
            carbs: '1234 ****',
            date: '24 Jan, 10.30 AM',
            amount: '-750',
            image_url: require('@/assets/icon/person.png')
          },
        ],

        weekly: {
          series: [{
            name: 'Debit',
            data: [44, 55, 57, 56, 61, 58, 40]
          }, {
            name: 'credit',
            data: [76, 85, 101, 98, 87, 105, 70]
          }],
          chartOptions: {
            chart: {
              type: 'bar',
              height: 350,
              toolbar: {
              show: false,
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 10,
                columnWidth: '55%'
              },
            },
            colors: ['#1A16F3', '#FCAA0B'],
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
            },
            xaxis: {
              categories: ['Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
            },
            yaxis: {
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false,
                formatter: function (val) {
                  return val + "%";
                }
              }
            
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return "$ " + val 
                }
              }
            },
          //   title: {
          //     text: 'undefined',
          //     align: 'left',
          //     margin: 10,
          //     offsetX: 0,
          //     offsetY: 0,
          //     floating: true,
          //     style: {
          //       fontSize:  '14px',
          //       fontWeight:  'bold',
          //       fontFamily:  undefined,
          //       color:  '#263238'
          //     },
          // }
          },
        },

        process: {
          load: true
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },


      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      
    },

    watch: {

    },
    mounted () {
      setTimeout(() => {
        this.process.load = false
      }, 1000)
    },
    methods: {
      
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;

    /* background-color: #4828a1; */
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  }


  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #4828a1;
  }
</style>